import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "nav nav-tabs mb-2" }
const _hoisted_2 = { class: "nav-item" }
const _hoisted_3 = {
  key: 0,
  class: "badge badge-info ml-1"
}
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = {
  key: 0,
  class: "badge badge-warning ml-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DBGrid = _resolveComponent("DBGrid")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'all' }]),
          href: "#",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.setTab('all')), ["prevent"]))
        }, [
          _cache[2] || (_cache[2] = _createTextVNode(" Накладные-требования ", -1)),
          (_ctx.allCount > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.allCount), 1))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'pending' }]),
          href: "#",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.setTab('pending')), ["prevent"]))
        }, [
          _cache[3] || (_cache[3] = _createTextVNode(" Заявки ", -1)),
          (_ctx.pendingCount > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.pendingCount), 1))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _createVNode(_component_DBGrid, {
      store: _ctx.store,
      config: _ctx.config,
      ref: "grid"
    }, null, 8, ["store", "config"])
  ]))
}